import React from 'react';
import ReactTable, { Filter } from 'react-table';
import 'react-table/react-table.css';
import { Button, Progress } from 'reactstrap';
import { Link } from 'react-router-dom';
import CristalScoreCell from '../../../containers/Cards/Patient/Table/CristalScoreCell';

export type PatientItem = {
  id: string;
  firstName: string;
  lastName: string;
  dob: string;
  mrn: string;
  gender: string;
  progress: string;
  score: string;
};

const PatientsTable = ({
  patients,
  loading,
  organizationId,
  onFetchData,
  page,
  last,
  onPageChange,
  filtered,
}: {
  patients: PatientItem[];
  loading?: boolean;
  filtered: Filter[];
  organizationId?: string;
  onFetchData: (state: any, instance: any) => void;
  onPageChange: (page: number) => void;
  last?: boolean;
  page: number;
}) => (
  <ReactTable
    filtered={filtered}
    className={'-highlight'}
    loading={loading}
    data={patients}
    sortable={false}
    page={page}
    pages={last ? page + 1 : page + 2}
    showPageJump={false}
    previousText="Reset"
    showPageSizeOptions={false}
    onPageChange={onPageChange}
    pageSize={20}
    manual
    onFetchData={onFetchData}
    columns={[
      {
        Header: 'First Name',
        accessor: 'firstName',
        filterable: false,
        filterAll: true,
      },
      { Header: 'Last Name', accessor: 'lastName', filterable: false },
      { Header: 'Date of Birth', accessor: 'dob', filterable: false },
      { Header: 'MRN', accessor: 'mrn', resizable: false, filterable: false },
      {
        Header: 'Score',
        id: 'score',
        accessor: d => d,
        Cell: CristalScoreCell,
      },
      {
        Cell: props => {
          const { value } = props;
          return (
            <div>
              <Progress
                value={value}
                color={value === '100' ? 'success' : 'warning'}></Progress>
            </div>
          );
        },
        accessor: d => d.progress,
        id: 'progress',
        Header: 'Progress',
        resizable: false,
        filterable: false,
        sortable: false,
        maxWidth: 200,
      },
      {
        Cell: props => {
          const { value } = props;
          return (
            <div>
              <Button
                disabled={!organizationId}
                block
                tag={Link}
                to={`/organization/${organizationId}/patient/${value}/`}>
                View
              </Button>
            </div>
          );
        },
        accessor: d => d.id,
        id: 'buttons',
        resizable: false,
        sortable: false,
        filterable: false,
        maxWidth: 200,
      },
    ]}></ReactTable>
);
export default PatientsTable;
